import { debounce } from '@/util/debounce'
import { getTelco } from '@/api/airtime-data'
import { mapActions, mapGetters } from 'vuex'
import TelcoSkeletonLoader from '@/components/ui/TelcoSkeletonLoader'

export default {
    created() {
        this.debouncedGetTelco = debounce(this.getTelco, 1000)
        this.getTelcos()
        this.getDataCategories()
    },

    computed: {
        ...mapGetters('Telco', {
            telcos: 'GET_TELCOS',
            data_categories: 'GET_DATA_CATEGORIES',
            data_services: 'GET_DATA_SERVICES',
        }),
    },

    components: {
        TelcoSkeletonLoader,
    },

    methods: {
        ...mapActions('Telco', {
            getTelcos: 'FETCH_TELCOS',
            getDataCategories: 'FETCH_DATA_CATEGORIES',
        }),

        getTelco() {
            if (this.data.airtime_phone_number || this.data.data_phone_number) {
                this.loadingTelco = true
                getTelco(this.data.airtime_phone_number || this.data.data_phone_number)
                    .then((data) => {
                        this.loadingTelco = false
                        this.data.network = data.data.data.telco
                    })
                    .catch((err) => {
                        console.dir(err)
                    })
            } else {
                this.data.network = ''
            }
        },
    },
}
